import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b7aebd6b5d6f0014e75a43/netsiem/src/app/incident-management/components/IncidentTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b7aebd6b5d6f0014e75a43/netsiem/src/components/AppLayout.tsx");
